import {useHits, UseHitsProps} from 'react-instantsearch';
import {ChairliftChatCard} from '~/components/ChairliftChatCard.client';

export const BlogHits = (props: UseHitsProps) => {
  const {hits} = useHits(props);

  return hits?.length > 0 ? (
    <div className="grid grid-cols-2 lg:grid-cols-3 gap-x-5 lg:gap-x-[38px] gap-y-[30px] lg:gap-y-[70px] mt-5 md:mt-10">
      {hits.map((hit: any) => (
        <ChairliftChatCard
          key={hit.objectID}
          item={hit}
          replaceHistoryOnClick
        />
      ))}
    </div>
  ) : (
    <p className="font-sans text-16/24 max-w-[500px] text-start">No results</p>
  );
};
